p {
  font-size: 0.8em;
  color: silver;
  font-weight: 600;
}